import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { useEnrollments } from '@/hooks/use-enrollments'

export default function TeacherStudentsPage() {
  const { data, isLoading } = useEnrollments()

  const enrollments = data?.data ?? []

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">受講者一覧</h1>

      <Card>
        <CardHeader>
          <CardTitle>受講登録</CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <Skeleton className="h-48" />
          ) : enrollments.length === 0 ? (
            <p className="text-muted-foreground">受講者がいません。</p>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>受講者</TableHead>
                  <TableHead>コース</TableHead>
                  <TableHead>ステータス</TableHead>
                  <TableHead>登録日</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {enrollments.map((enrollment: any) => (
                  <TableRow key={enrollment.id}>
                    <TableCell>{enrollment.userName || enrollment.userEmail}</TableCell>
                    <TableCell>{enrollment.courseTitle}</TableCell>
                    <TableCell>{enrollment.status}</TableCell>
                    <TableCell>
                      {new Date(enrollment.enrolledAt).toLocaleDateString('ja-JP')}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
